<template>
    <!-- ========== MAIN ========== -->
    <main id="rooms_block_view">
        <div class="container">
            <div class="row">


                <div class="col-md-6 col-sm-6" v-for="room in rooms">
                    <article class="room_block_item">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <router-link v-bind:to="'/site/room/'+room.id" class="hover_effect h_link h_blue">
                                    <img v-bind:src="getImage(room)" class="img-responsive" alt="Image">
                                </router-link>
                            </div>
                            <div class="col-lg-6 col-md-12">
                                <div class="room_info">
                                    <h3>
                                        <router-link v-bind:to="'/site/room/'+room.id" >
                                            {{ room.name[currentLanguage] }}
                                        </router-link>
                                    </h3>
                                    <span v-if="room.price">$ {{ room.price || 0 }} / <i v-lang.night class="text-normal"></i></span>
                                    <p>{{ truncate(room.description[currentLanguage]) }}</p>
                                    <div class="room_services" v-if="room.services.length > 0">
                                        <i v-for="service in room.services" v-bind:class="service.icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>


            </div>
        </div>
    </main>
</template>

<script>
    import DefaultComponent from './Component';
    export default
    {
        props : DefaultComponent.props,
        methods : DefaultComponent.methods,
        computed : DefaultComponent.computed
    }
</script>

<style>
    .text-normal
    {
        font-weight: normal !important;
    }
</style>


// WEBPACK FOOTER //
// BlockView.vue?32e38b22